import { render } from "./BaseShapeElement.vue?vue&type=template&id=5f239870&scoped=true&ts=true"
import script from "./BaseShapeElement.vue?vue&type=script&lang=ts"
export * from "./BaseShapeElement.vue?vue&type=script&lang=ts"

import "./BaseShapeElement.vue?vue&type=style&index=0&id=5f239870&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f239870"]])

export default __exports__